import { GOOGLE_ADS_CAMPAIGN_STATUS } from '../../../../../../../services/exports/Constants';

export default {
  buttons: {
    back: 'Tilbage',
  },
  metrics: {
    impressions: {
      label: 'Visninger',
      description: 'Antal gange, din annonce blev vist i Googles søgeresultater eller på partnerwebsteder.',
    },
    clicks: {
      label: 'Klik',
      description: 'Antal gange, folk har klikket på din annonce.',
    },
    budget_spent: {
      label: 'Brugt budget',
      description: 'Det samlede beløb, der er brugt på denne kampagne.',
    },
    absolute_top_impression_percentage: {
      label: 'Andel af absolut topvisninger',
      description: 'Den procentdel af gange, din annonce blev vist helt øverst i Googles søgeresultater.',
    },
    phone_calls: {
      label: 'Opkald',
      description: 'Det samlede antal telefonopkald modtaget fra din annonce.',
    },
    phone_impressions: {
      label: 'Telefonvisninger',
      description: 'Antal gange, dit telefonnummer blev vist i annoncen.',
    },
    phone_through_rate: {
      label: 'Opkaldsrate',
      description: 'Den procentdel af telefonvisninger, der resulterede i faktiske opkald (opkald ÷ telefonvisninger).',
    },
    directions: {
      label: 'Rutevejledninger',
      description: 'Antal gange, brugere har klikket for at få rutevejledning til din virksomheds adresse.',
    },
    daily_budget: {
      label: 'Dagligt budget',
      description: 'Det maksimale beløb, der er sat til at blive brugt pr. dag på denne kampagne.',
    },
    status: {
      label: 'Status',
      description: 'Din kampagnes aktuelle status.',
    },
    ctr: {
      label: 'Klikrate',
      description: 'Den procentdel af annoncevisninger, der resulterede i klik (klik ÷ visninger).',
    },
    average_cpc: {
      label: 'Gennemsnitlig pris pr. klik',
      description:
        'Det gennemsnitlige beløb, du betaler, hver gang nogen klikker på din annonce (samlede omkostninger ÷ samlede klik).',
    },
    conversions_from_interactions_rate: {
      label: 'Konverteringsrate',
      description: 'Den procentdel af annonceinteraktioner, der førte til en konvertering.',
    },
    start_date: {
      label: 'Startdato',
      description: 'Datoen, hvor kampagnen startede.',
    },
    sales_from_google_ads: {
      label: 'Salg fra Google Ads',
      description: 'Det samlede beløb, der er genereret via Google Ads.',
    },
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Ikke angivet',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Aktiveret',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Sat på pause',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Ukendt',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Fjernet',
  },
  error_messages: {
    loading_failed: 'Kampagnedetaljerne kunne ikke indlæses. Prøv igen.',
  },
};
